import { ComponentType } from "react";

export const withBankAccountNumberInput = <T,>(
    InputComponent: ComponentType<T>,
) => {
    const onInputBankAccountNumberOnly = (
        e: React.ChangeEvent<HTMLInputElement>,
    ) => {
        e.target.value = e.target.value.replace(/[^A-Z0-9-]/g, "");
    };

    return (props: T) => {
        return (
            <InputComponent {...props} onInput={onInputBankAccountNumberOnly} />
        );
    };
};
